/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PostPermissions } from './postPermissions';
import { SocialContext } from './socialContext';

export interface PostBase { 
    entity_id: string;
    permissions: PostPermissions;
    title: string;
    date: string;
    social_context: SocialContext;
}